/* unplugin-vue-components disabled */import { render } from "./jobs.vue?vue&type=template&id=3358609a&scoped=true"
import script from "./jobs.vue?vue&type=script&lang=js"
export * from "./jobs.vue?vue&type=script&lang=js"

import "./jobs.vue?vue&type=style&index=0&id=3358609a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3358609a"],['__file',"src/components/cards-v2/persona/jobs/jobs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3358609a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3358609a', __exports__)) {
    api.reload('3358609a', __exports__)
  }
  
  module.hot.accept("./jobs.vue?vue&type=template&id=3358609a&scoped=true", () => {
    api.rerender('3358609a', render)
  })

}


export default __exports__